import { getEditTranslationsPrivilege } from '@skytech/utils'

import type { TokenData } from '@/types'

const getUserFromToken = (tokenData: TokenData) => {
  const user = {
    whiteLabelId: tokenData.wlid,
    costObjectId: tokenData.coid,
    customerId: tokenData.cid,
    customerHeadId: tokenData.chid,
    role: tokenData.role,
    code: tokenData.code,
    editTranslationsPrivilege: getEditTranslationsPrivilege(tokenData.ia),
  }

  return user
}

export default getUserFromToken
